import styled from "styled-components";
import {
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONTS,
} from "../../../../constants/Styles";

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
`;

export const ErrorText = styled.div`
  color: ${COLORS.error};
  font-size: ${FONT_SIZE.size13};
`;

export const QuoteHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuoteHistoryItem = styled.div`
  border-radius: 1rem;
  ${CARD_BACKGROUND};
  display: flex;
  gap: 1rem;
  padding: 1rem;
  flex-wrap: wrap;
`;

export const ItemsModalContent = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const ShipmentsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 16rem;
`;

export const ShipmentsTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size14};
  color: ${COLORS.secondary};
`;

export const ShipmentRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;
